
import styled from 'styled-components';
import * as theme from '@zero/design-tokens/build/js/variables';

export const SC_Slider =styled.div`
    position: relative;
    &::after {
        content: "";
        display: block;
        height: 2px;
        background: ${theme.ZrColorNeutralMedium03};
    }
`
